import { Observable, UnaryFunction, map, pipe, skipWhile } from 'rxjs';


/**
 * Creates an RxJS operator that skips values in an observable stream based on certain conditions.
 *
 * @param {skipperOptions} [options] - An optional object that specifies the conditions for skipping values.
 * @param {boolean} [options.skipEmptyArrays=true] - If true, when an empty array exists amonge sources it will skip emitting any value.
 * @param {boolean} [options.checkAll=true] - If true, all sources should be truthy (or non-empty arrays if skipEmptyArrays is true) to any value be emitted
 *
 * @returns {UnaryFunction<Observable<T>, Observable<T>>} - An RxJS operator function that can be used to skip values in an observable stream.
 */
export function skipper<T>(options: skipperOptions = {checkAll: true, skipEmptyArrays: true}): UnaryFunction<Observable<T>, Observable<T>> {
  return pipe(
    map((values: T) => values),
    skipWhile((values: T) => {
      if (Array.isArray(values)) {
        if (options?.checkAll) {
          return values.some(value => !isTruthy(value,options.skipEmptyArrays))
        } else {
          return values.every(value => !isTruthy(value,options.skipEmptyArrays))
        }
      } else {
        return !values
      }
    })
  );
}

function isTruthy(value: unknown, skipEmptyArrays: boolean): boolean {
  if (Array.isArray(value)) {
    return Boolean(value) && skipEmptyArrays ? value.length > 0 : true
  } else {
    return Boolean(value)
  } 
}



export interface skipperOptions {
  skipEmptyArrays?: boolean;
  checkAll?: boolean;
}
